import SlotManagerLarge from "./SlotManagerLarge";

export default SlotManagerLarge;
export { SlotManagerLarge };
